export default __webpack_public_path__ + "static/media/pagos.ffe23608.png";